export default __webpack_public_path__ + "location_pin.8c16f3760640ca7bb9fd99c524d408ed.svg";